import { Layout, theme } from "antd";
import React, { Fragment, useState } from "react";
import { DownOutlined } from "@ant-design/icons";
import { Avatar, Drawer, Dropdown, Menu, Space } from "antd";
import { useNavigate } from "../../../node_modules/react-router-dom/dist/index";
import "./index.css";
import { useSelector } from "react-redux";
const { Header } = Layout;

const AppHeader = () => {
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  const user = useSelector((state) => state.auth.user);

  const [open, setOpen] = useState(false);
  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };
  const navigate = useNavigate();
  const onClick = ({ key }) => {
    navigate(key);
  };
  const menu = (
    <Menu
      onClick={onClick}
      items={[
        {
          label: "View Profile",
          key: "/profile",
        },
        {
          label: "Logout",
          key: "/logout",
        },
      ]}
    />
  );
  return (
    <Fragment>
      <div className="flex_between header_container">
        <Drawer
          rootClassName="Header_Drawer"
          title="Voo Chat"
          placement="right"
          onClose={onClose}
          open={open}
          width={200}
          headerStyle={{ background: "#001529" }}
          bodyStyle={{ padding: "0 " }}
        >
          {/* <ResponsiveMenu /> */}
        </Drawer>

        <div className="name">
          Hello, <strong>{user?.name}</strong>
        </div>

        <div className="flex_items">
          <Dropdown overlay={menu}>
            <Space className="cursor-pointer">
              <Avatar src="" size="large" />
              <DownOutlined />
            </Space>
          </Dropdown>
        </div>
      </div>
    </Fragment>
  );
};

export default AppHeader;
